import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface RelatedNewsProps {
  items: NewsItem[];
  title?: string;
  emptyText?: string;
}

function target(item: NewsItem): string {
  if (item.relatedFilm) return `/detail/film/${item.relatedFilm}`;
  if (item.relatedActor) return `/detail/actor/${item.relatedActor}`;
  return `/search?q=${encodeURIComponent(item.tag)}`;
}

export default function RelatedNews({
  items,
  title = "资讯动态",
  emptyText = "暂时没有该作品的相关资讯，敬请期待。",
}: RelatedNewsProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <div className="px-5 py-4 border-b border-background-200">
        <h2 className="font-heading font-bold text-lg text-foreground-950">
          {title}
        </h2>
      </div>
      {items.length > 0 ? (
        <ul className="divide-y divide-background-200">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={target(item)}
                className="group flex items-start gap-3 p-4 md:p-5 hover:bg-background-100 transition-colors"
              >
                <span className="mt-0.5 shrink-0 px-2 h-6 flex items-center rounded-md bg-secondary-100 text-secondary-900 text-xs">
                  {item.tag}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-medium text-foreground-900 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
                    {item.summary}
                  </p>
                  <p className="mt-1 text-xs text-foreground-400">{item.date}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="p-5 text-sm text-foreground-500">{emptyText}</p>
      )}
    </section>
  );
}